/**
 * Chart value formatting.
 *
 * Mirrored by Chart\ChartData::format_value() in PHP. Change both together.
 */

import { toNumber } from './geometry';

/**
 * Format a value the way the chart's axis, labels, tooltip and table all show it.
 *
 * One function for all four so a number never reads differently depending on
 * where you found it.
 *
 * @param {number} value   Raw value.
 * @param {Object} options Formatting attributes.
 * @return {string} Formatted value.
 */
export function formatValue( value, options = {} ) {
	const {
		decimals = 0,
		thousandSeparator = true,
		valuePrefix = '',
		valueSuffix = '',
	} = options;

	const fixed = toNumber( value ).toFixed( Math.max( 0, decimals ) );
	let [ whole, fraction ] = fixed.split( '.' );

	if ( thousandSeparator ) {
		const negative = whole.startsWith( '-' );
		const digits = negative ? whole.slice( 1 ) : whole;
		whole =
			( negative ? '-' : '' ) +
			digits.replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
	}

	const number = fraction !== undefined ? `${ whole }.${ fraction }` : whole;

	return `${ valuePrefix }${ number }${ valueSuffix }`;
}

/**
 * Format a share as a whole percentage, for pie and donut labels.
 *
 * @param {number} share Fraction 0–1.
 * @return {string} Percentage.
 */
export function formatShare( share ) {
	return `${ Math.round( share * 1000 ) / 10 }%`;
}
